module.exports = __webpack_public_path__ + "profile.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pictures/profile.png
// module id = 106
// module chunks = 0